<template>
  <el-dialog
    :title="$t('Datalang.VIP_TIP_betting')"
    :visible.sync="showDetail"
    :before-close="handleClose"
    :append-to-body="true"
    class="detailDialog"
    width="700px"
  >
    <div :key="showDetail" class="detail-wrap">
      <div
        class="game-info"
        v-exposure="{ eid: `120_0_0_0`, gameGroupSid: curItem.gameGroupSid }"
        :data-id="`120_0_0_0`"
      >
        <img class="game-thumb" :src="$utils.returnImgUrl(curItem.gamePcIcon)" alt="" />
        <div class="game-right">
          <div class="top">
            <div class="game-name">{{ $t("Datalang.Betrecord_TITLE_gamename") }}：{{ curItem.gameName }}</div>
            <div class="game-brand">{{ curItem.brandName || curItem.brandGroupName || "" }}</div>
            <el-button v-if="!IsMobile" type="primary" class="game-btn" @click="playGame">{{
              $t("Datalang.Go_to_game")
            }}</el-button>
          </div>
          <el-button v-if="IsMobile" type="primary" class="game-btn" @click="playGame">{{
            $t("Datalang.Go_to_game")
          }}</el-button>
          <div class="game-user" v-if="!IsMobile">
            <div class="user-info">
              <div class="user-info-label">{{ $t("Datalang.Leaderboard_Player") }}</div>
              <div class="user-info-value">{{ curItem.userName }}</div>
            </div>
            <div class="user-date">
              <div class="user-date-label">{{ $t("Datalang.VIPSpin_Spin_Time") }}</div>
              <div class="user-date-value">{{ formatTimeToString(curItem.createdAt) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-game-user" v-if="IsMobile">
        <div class="game-user">
          <div class="user-info">
            <div class="user-info-label">{{ $t("Datalang.Leaderboard_Player") }}</div>
            <div class="user-info-value">{{ curItem.userName }}</div>
          </div>
          <div class="user-date">
            <div class="user-date-label">{{ $t("Datalang.VIPSpin_Spin_Time") }}</div>
            <div class="user-date-value">{{ formatTimeToString(curItem.createdAt) }}</div>
          </div>
        </div>
      </div>
      <div class="win-info">
        <div class="col">
          <div class="col-title">{{ $t("Datalang.VIP_TIP_betting") }}</div>
          <div class="col-value flex">
            <img v-if="curItem.coin_icon" :src="$utils.returnImgUrl(curItem.coin_icon)" class="card-cion" alt="" />
            <span class="pl5">{{ divideSymbol(curItem.betAmount) }}</span>
          </div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t("Datalang.Multiplier_Home") }}</div>
          <div class="col-value">
            <span>{{ divideSymbol(curItem.multiple) }}x</span>
          </div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t("Datalang.Win_Loss") }}</div>
          <div class="col-value">
            <div class="total-wrap">
              <div class="total">
                <img
                  v-if="curItem.coin_icon"
                  :src="$utils.returnImgUrl(curItem.coin_icon)"
                  class="cion"
                  alt=""
                  srcset=""
                />
                <span :class="curItem.gameRewardAmount > 0 ? 'color-green' : 'color-origin'">{{
                  divideSymbol(curItem.gameRewardAmount)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { divideAccuracy, divideSymbol } from "@/lobby_common/utils/utils.js";
import { formatTimeToString } from "@/lobby_common/utils/date";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
export default {
  name: "jpDetailDialog",
  data() {
    return {
      formatTimeToString,
      divideSymbol,
      showDetail: false,
      curItem: {},
    };
  },
  computed: {
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    getSite() {
      return this.$store.getters.getPacketConfig?.site || {};
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.coinList || [];
    },
  },
  methods: {
    divideAccuracy,
    show(item) {
      item = JSON.parse(JSON.stringify(item));
      this.curItem = item;
      this.showDetail = true;
    },
    handleClose() {
      this.showDetail = false;
    },
    playGame() {
      this.showDetail = false;
      if (!this.$store.getters.taken) {
        this.$Bus.$emit("showLogin");
        return;
      }
      this.$store.commit("setRecordGame", this.curItem);
      payGameFun({ ...this.curItem, eid: `120_0_0_0` });
      // this.$PayGame(this.curItem.gameGroupSid, this.curItem);
    },
  },
};
</script>
<style lang="scss">
body.black-theme .detailDialog .el-dialog {
  max-width: 95vw !important;
  .el-dialog__body {
    padding: 25px;
    @media screen and (max-width: 768px) {
      padding: 15px;
    }
  }
  .el-icon-close {
    color: var(--font-color-100);
    font-size: 20px;
  }
}
</style>
<style lang="scss" scoped>
.detail-wrap {
  .total-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .total {
    display: flex;
    align-items: center;
    .cion {
      margin-right: 4px;
      width: 22px;
      height: 22px;
    }
  }
  .game-btn {
    position: absolute;
    right: 0;
    top: 0;
    @include buttonPrimary;
    padding: 10px 20px;
    max-width: 150px;
    @media screen and (max-width: 768px) {
      position: unset;
      right: unset;
      top: unset;
    }
  }
  .game-info {
    display: flex;
    align-content: flex-start;
    .game-thumb {
      width: 172px;
      height: 230px;
      border-radius: var(--radius-100);
      @media screen and (max-width: 768px) {
        width: 112px;
        height: 150px;
        border-radius: var(--radius-100);
      }
    }
    .game-right {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 20px;
      .game-name {
        height: 38px;
        padding: 10px 0;
        font-size: 18px;
        color: var(--font-color-100);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden; /*! autoprefixer: off */
        -webkit-box-orient: vertical;
      }
      .game-brand {
        padding: 10px 0;
        font-size: 16px;
        color: var(--font-color-900);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .m-game-user {
    margin-top: 15px;
  }
  .game-user {
    padding: 20px 18px;
    width: 100%;
    border-radius: var(--radius-100);
    background-color: var(--background-1001);
    font-size: 14px;
    box-sizing: border-box;
    @media screen and (max-width: 768px) {
      padding: 12px;
    }
    .user-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 26px;
      @media screen and (max-width: 768px) {
        padding-bottom: 15px;
      }
      &-label {
        color: var(--font-color-200);
      }
      &-value {
        color: var(--font-color-300);
      }
    }
    .user-date {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-label {
        color: var(--font-color-200);
      }
      &-value {
        color: var(--font-color-300);
      }
    }
  }
  .win-info {
    margin-top: 35px;
    display: flex;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      margin-top: 25px;
    }
    .col {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &-title {
        padding-bottom: 20px;
        font-size: 16px;
        color: var(--font-color-900);
        @media screen and (max-width: 768px) {
          padding-bottom: 12px;
        }
      }
      &-value {
        color: var(--font-color-100);
        font-size: 16px;
      }
    }
  }
}
.text-center {
  text-align: center;
}
.color-origin {
  color: var(--font-color-1500);
}
.color-green {
  color: var(--font-color-1000);
}
.flex {
  display: flex;
  align-items: center;
}
.pl5 {
  padding-left: 5px;
}
.pointer {
  cursor: pointer;
}
.card-cion {
  width: 22px;
  height: 22px;
}
</style>
